/* global G */
import { modelComposition } from 'trait/composition'
import { pipe } from 'lib/util'
import { usesGetterSetter } from 'trait/uses'
import toString from 'model/_shared/transformer/toString'
import toExplicitBoolean from 'model/_shared/transformer/toExplicitBoolean'

const descriptor = 'model::ticket::billing'

export default pipe(
  modelComposition(descriptor),
  usesGetterSetter(G.TRANSFORMER, {
    chargeable: toExplicitBoolean('chargeable'),
    costObject: toString('costObject'),
  }),
)
